import L from 'leaflet';
import PlaceType from './PlaceType';
import Photo from './Photo';
import VideoLink from './VideoLink';
import markerIcons from '@/ts/markerIcons';
import { DataOrigin } from './types';

export default class Place {

  public photos: Photo[];
  public videos: VideoLink[];

  public markerLat: Number;
  public markerLon: Number;

  public link: string;

  private placeAddedToStore = false;
  public markerAction: string;
  public wayPointsPolylines: L.Polyline[];

  public getMarker() {
    return window.leaflet.markers[this.from_type][this.id];
  }

  constructor(public id: number, public name: string, public description: string, public lat: number, public lon: number, public type: PlaceType, public approved: boolean, public waypoints: [], public from_type: DataOrigin, public is_active: boolean) {
    this.photos = [];
    this.videos = [];
    this.markerLat = lat;
    this.markerLon = lon;
  }

  public createWayPointsPolylines() {
    this.wayPointsPolylines = [];
    for(const segment of this.waypoints) {
      const poliline = new L.Polyline(segment, {
        color: 'red',
        weight: 5,
        opacity: 1,
        smoothFactor: 1,
      });
      this.wayPointsPolylines.push(poliline);
    }
  }

  public addWayPointsPolylinesToMap() {
    for(const poliline of this.wayPointsPolylines) {
      poliline.addTo(window.mainmap);
      poliline.bringToFront();
      this.getMarker().bringToFront();
    }
  }

  public removeWayPointsPolylinesFromMap() {
    for(const poliline of this.wayPointsPolylines) {
      poliline.removeFrom(window.mainmap);
    }
  }

  public createMarker() {
    const draggable = Boolean(this.from_type == DataOrigin.maplas && window.window.isDesktop && window.$store.state.user)
    const size = this.getMarkerSize(window.mainmap.getZoom());
    const anchor = this.getMarkerAnchor(window.mainmap.getZoom());
    let marker = null;
    if ((this.type) && (this.type.icon instanceof Object)) {
      marker = new L.CircleMarker([this.lat, this.lon], {radius: size / 2, color: this.type.icon.color});
    } else {
      const markerIconClass = this.getMarkerIconClass();
      // @ts-ignore
      const markerIcon = L.icon({iconSize: [size, size], iconAnchor: [anchor, anchor], iconUrl: markerIcons[markerIconClass]});
      marker = new L.Marker([this.lat, this.lon], {icon: markerIcon, draggable: draggable, contextmenu: false, contextmenuItems: []});
    }
    marker.on("click", (event) => {
      if (! this.placeAddedToStore) {
        window.$store.state.maplasPlaces[this.from_type].push(this);
        this.placeAddedToStore = true;
        this.markerAction = 'click';
      }
      this.markerLat = marker.getLatLng().lat;
      this.markerLon = marker.getLatLng().lng;
      L.DomEvent.stopPropagation(event);
    });
    if ((this.waypoints) && (this.waypoints.length > 0)) {
      marker.on("mouseover", (event) => {
        if (! this.placeAddedToStore) {
          this.createWayPointsPolylines();
          window.$store.state.maplasPlaces[this.from_type].push(this);
          this.placeAddedToStore = true;
        }
        if (this.wayPointsPolylines) {
          this.addWayPointsPolylinesToMap();
        }
      });
      marker.on("mouseout", (event) => {
        if (this.wayPointsPolylines) {
          this.removeWayPointsPolylinesFromMap();
        }
      });
    }
    window.leaflet.markers[this.from_type][this.id] = marker;
  }

  public convertToApiPlaceSave() {
    return {id: this.id, name: this.name, description: this.description, lat: this.lat, lon: this.lon, type: this.type.id};
  }

  public setDraggable(drag: boolean) {
    const marker = this.getMarker();
    if (marker instanceof L.Marker) {
      if (marker.dragging) {
        if (drag) {
          marker.dragging.enable();
        } else {
          marker.dragging.disable();
        }
      }
    }
  }

  public addPhoto(photo: Photo) {
    this.photos.push(photo);
  }

  public addVideo(video: VideoLink) {
    this.videos.push(video);
  }

  public getMarkerSize(zoomLevel: number) {
    if (this.from_type == DataOrigin.maplas) {
      if (zoomLevel <= 11) {
        return 13;
      }
      if (zoomLevel <= 14) {
        return 21;
      }
      if (zoomLevel <= 16) {
        return 37;
      }
      return 49;
    } else {
      return 13;
    }
  }

  public getMarkerAnchor(zoomLevel: number) {
    return Math.floor(this.getMarkerSize(zoomLevel) / 2);
  }

  public getMarkerIconClass() {
    if (this.type) {
      if (this.type.icon) {
        if (this.type.icon instanceof Object) {
          return 'maplas_other';
        } else {
          return this.type.icon.replaceAll('-', '_');
        }
      } else {
        return 'maplas_other';
      }
    } else {
      return 'maplas_other';
    }
  }

  public changeMarkerSize(zoomLevel: number) {
    const marker = this.getMarker();
    if (marker instanceof L.Marker) {
      const markerIconClass = this.getMarkerIconClass();
      const size = this.getMarkerSize(zoomLevel);
      const anchor = this.getMarkerAnchor(zoomLevel);
      const markerIcon = L.icon({
        iconSize: [size, size],
        iconAnchor: [anchor, anchor],
        // @ts-ignore
        iconUrl: markerIcons[markerIconClass],
      });
      marker.setIcon(markerIcon);
    }
  }
}
